import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { Background } from './Background';
import { FADE, MAX_LEADERS } from '../../HOME/const';
import * as f from '../logic';
import LeaderItem from '../../HOME/COMPONENTS/LeaderItem';
import { BEGINNER, JUNIOR, SENIOR, GRADUATE, HUMAN_VS_ROBOT } from '../const';
import { TA_BACKGROUND } from '../const';
import { setUserId, showLeaderboards } from '../../HOME/REDUX/actions';
import LeaderBase from '../../HOME/COMPONENTS/LeaderBase';
import BackButton from './BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { getDate, scrollClass } from '../../HOME/utils';
import _ from 'lodash';

class Leaderboard extends LeaderBase {
  state = {
    ...this.state,
    skill: this.props.skill,
    size: this.props.size,
    score: this.props.stats ? this.props.stats.grade : 0,
  };

  componentDidMount() {
    this.init(this.handleSelection);
  }

  getQuery = () => {
    const { skill, size } = this.state;

    return this.leaders
      .where('skill', '==', skill)
      .where('size', '==', size)
      .orderBy('score', 'desc')
      .orderBy('plays', 'desc')
      .limit(MAX_LEADERS);
  };

  cacheKey(skill, size) {
    skill = skill || this.state.skill;
    size = size || this.state.size;

    return `${this.props.app} LEADERS • ${skill.slice(0, 1)}${size}`;
  }

  userKey(id, size, skill) {
    id = id || this.props.uid;
    size = size || this.state.size;
    skill = skill || this.state.skill;

    return `${skill.slice(0, 1)}${size} • ${id}`;
  }

  handleSelection = (skill, size) => {
    skill = skill || this.state.skill;
    size = size || this.state.size;

    this.setState({ skill, size }, () => {
      this.getCachedLeaders(true);

      f.getStats({ players: HUMAN_VS_ROBOT, skill, size }, stats => {
        const { grade, plays } = f.getMoreStats(stats, this.state.size);
        this.setState({ score: grade, plays }, this.updateRanks);
      });
    });
  };

  dataToSubmit = () => {
    const { skill, size, score, plays } = this.state;
    return { skill, size, name: this.state.name.trim(), score, plays, date: getDate() };
  };

  renderNavigation = () => (
    <>
      <BackButton />
      <HomeButton />
    </>
  );

  render() {
    const background = TA_BACKGROUND;
    const rankColor = 'rgb(194, 125, 236)';
    const dateColor = 'rgb(186, 79, 252)';
    const submitColor = 'rgb(58, 16, 82)';
    const scoreAlias = 'Grade';

    return (
      <>
        <div className={`leaders-screen ${this.props.showLeaders === FADE ? 'fadeout' : ''}`}>
          {this.renderClickableScreen()}
          <div className="leaders fadein-fast" style={{ background, backgroundImage: Background, color: 'white' }}>
            <div className="leaders-selector">
              {_.map([BEGINNER, JUNIOR, SENIOR, GRADUATE], skill => {
                const icon = f.skillIcon(this.props, skill);
                const current = skill === this.state.skill;
                const cls = `leaders-selector-item ${current ? 'leaders-selector-item-current' : ''}`;
                return (
                  <div key={skill} className={cls} onClick={() => this.handleSelection(skill)}>
                    <img src={icon} height="40" alt={skill} />
                  </div>
                );
              })}
              {_.map([3, 4, 5, 6, 7], size => {
                const current = size === this.state.size;
                const sizeName = f.sizeName(size);
                const cls = `leaders-circle leaders-size-selector leaders-selector-item ${current ? 'leaders-selector-item-current' : ''}`;
                return (
                  <div key={size} className={cls} style={{ margin: '0 0.2em' }} onClick={() => this.handleSelection(null, size)}>
                    {sizeName}
                  </div>
                );
              })}
            </div>
            <div className={scrollClass} style={{ gridArea: '2/1', display: 'initial' }}>
              {_.map(this.state.users, (u, i) => (
                <LeaderItem key={i} rank={i + 1} data={u.data} rankColor={rankColor} dateColor={dateColor} scoreAlias={scoreAlias} />
              ))}
            </div>
            {this.renderCommon(rankColor, submitColor, scoreAlias)}
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps({ ta, common }) {
  return { ...ta, ...common };
}

export default connect(
  mapStateToProps,
  { setUserId, showLeaderboards }
)(Leaderboard);
